<mat-form-field class="mat-block mat-block_placeholder-top mat-block_with_symbol position-relative"
                [attr.data-symbol]="COST_INPUT_CONFIG.unit"
                [formGroup]="form">
  <i *ngIf="showTooltip$ | async"
     [matTooltip]="COST_INPUT_CONFIG.tooltipText"
     class="material-icons icon-help info-cell-icon cursor-pointer"
     matTooltipPosition="below">help_outline</i>
  <input matInput
         npNumber
         [formControlName]="controlName"
         [placeholder]="COST_INPUT_CONFIG.placeholder"
         [maxValue]="COST_INPUT_CONFIG.maxValue"
         [allowFloat]="COST_INPUT_CONFIG.allowFloat"
         [digitsAfterDot]="COST_INPUT_CONFIG.digitsAfterDot"
         [NumberInput]="true" />
</mat-form-field>
